import { render, staticRenderFns } from "./EmailCollects.vue?vue&type=template&id=94aa1df8"
import script from "./EmailCollects.vue?vue&type=script&lang=ts"
export * from "./EmailCollects.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports